import { render } from "./spinner.vue?vue&type=template&id=967b57a6&ts=true"
import script from "./spinner.vue?vue&type=script&lang=ts"
export * from "./spinner.vue?vue&type=script&lang=ts"

import exportComponent from "/mobefind/admin/auth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__